module.exports = __webpack_public_path__ + "static/media/community_image2.fdddb45a.webp";